import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';

export const HJCloudModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegularBold>
                To move forward with Autofulfill setup, please complete the following items:
            </UiKit.Text.BodyRegularBold>
            <UiKit.Chakra.UnorderedList>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Create a unique, dedicated user account specifically for Autofulfill
                    </UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                Do not submit personal staff credentials
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                Credentials should be exclusive to this connection and not shared or used by
                                other users
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        If an email is required for account creation, please use:
                    </UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>Email: support@healthjump.com</UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>Phone (for 2FA): (215) 440-6126</UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                If multi-factor authentication is required, we prefer Google Authenticator
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Grant the account access equivalent to that of a practice administrator:
                    </UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                Permissions should reflect those of a live staff member who would typically
                                fulfill audit requests
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                The account must have access to all clinical and scheduling data necessary to
                                complete audits
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegularBold>
                        Please provide the relevant credentials to requestmanager@datavant.com to proceed with
                        setup
                    </UiKit.Text.BodyRegularBold>
                </UiKit.Chakra.ListItem>
            </UiKit.Chakra.UnorderedList>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Close'} onClick={props.onClose} />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'3xl'}
            fullScreen={false}
        />
    );
};
